<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/178cWnm/tc-custom/9781466882553.jpg?1732052886452" alt="This image is the cover for the book Zodiac Spells"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Zodiac Spells
      </h1>
      <p class="bookDescription body article font2">
        <p>In <i>Zodiac Spells</i>, Lexa Rosean has put together her most exciting collection yet: a book that marries astrology with Wiccan practice. Here you will discover how different spells work for different sun signs and how to maximize a spell using your date, time, and place of birth. <br/><br/>In this enchanting collection you will learn how:<br/><br/>*Almonds can help a Virgo heal a minor illness<br/>*Mint, chocolate, and chili powder can help a Scorpio attract anyone<br/>*A Taurus can get money using thyme and spinach<br/>*A Gemini can use pistachio nuts and pomegranate seeds for flirtation and romance<br/>*Libras can use rose water, cardamom, caraway, and mint to achieve balance and success<br/>*What spells your zodiac sign should avoid--and when they're safe to use<br/>*And much more!<br/><br/>Let "the Martha Stewart of Witches" guide you though these fun, enchanting spells that call for simple ingredients and easy steps.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lexa Roséan
      </h2>
      
      <p class="authorDescription body article"><P>Recipient of the Golden Broom award, <B>Lexa Rosean</B> is a Wiccan High Priestess and professional psychic consultant in NYC.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Griffin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ddf143f6